import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = {
    source: String,
    originalText: String
  }

  connect() {
    // Store full original HTML only once
    if (this.hasButtonTarget && !this.hasOriginalTextValue) {
      this.originalTextValue = this.buttonTarget.innerHTML
    }
  }

  copy() {
    navigator.clipboard.writeText(this.sourceValue).then(() => {
      this.showSuccess()
    })
  }

  showSuccess() {
    if (this.hasButtonTarget) {
      this.buttonTarget.innerHTML = "Copied!"

      setTimeout(() => {
        this.buttonTarget.innerHTML = this.originalTextValue
      }, 1500)
    }
  }
}